import React from 'react';
import styles from './ProductImageGallery.module.scss';

// const BACKEND_URL = 'http://localhost/tramhuong';
const BACKEND_URL = 'https://huongtramcomoc.vn';
const ProductImageGallery = ({ imagesString }) => {
  // 1. Xử lý trường hợp không có chuỗi ảnh
  if (!imagesString || typeof imagesString !== 'string') {
    return <div className={styles.noImage}>Chưa có ảnh</div>;
  }

  // 2. Tách chuỗi thành mảng và lọc bỏ các phần tử rỗng
  const images = imagesString.split(',').filter(img => img.trim() !== '');

  if (images.length === 0) {
     return <div className={styles.noImage}>Chưa có ảnh</div>;
  }

  // 3. Chỉ lấy tối đa 3 ảnh để hiển thị
  const displayImages = images.slice(0, 3);
  const remainingCount = images.length - 3;

  return (
    <div className={styles.galleryContainer}>
      {displayImages.map((imgFn, index) => {
        // --- ĐIỂM QUAN TRỌNG NHẤT TRONG JSX ---
        // Tính toán z-index: Ảnh đầu tiên (index 0) có z-index cao nhất.
        // Ví dụ có 3 ảnh: ảnh 1 (z:3), ảnh 2 (z:2), ảnh 3 (z:1)
        const zIndexValue = displayImages.length - index;
        // --------------------------------------

        return (
          <div 
            key={index} 
            className={styles.imageWrapper} 
            style={{ zIndex: zIndexValue }} 
          >
            <img 
              src={`${BACKEND_URL}${imgFn}`} 
              alt="thumbnail" 
              className={styles.thumbImg}
              onError={(e) => {e.target.src = 'https://placehold.co/50?text=Error';}} // Xử lý khi ảnh lỗi
            />
            
            {/* Hiển thị số lượng ảnh còn lại ở ảnh cuối cùng */}
            {index === 2 && remainingCount > 0 && (
              <div className={styles.moreCount}>+{remainingCount}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProductImageGallery;